import { User } from "@/generated/graphql";

export default function isContractorInCompany(applicant: User): boolean {
  const contractor = applicant.contracts?.[0];
  if (!contractor) {
    return false;
  }
  const { deleted, approved } = contractor;
  return !deleted && approved;
}

export function getContractorIfInSameCompany(applicant: User) {
  const contractor = applicant.contracts?.[0];
  if (!contractor) {
    return false;
  }
  const { deleted, approved } = contractor;
  return !deleted && approved ? contractor : false;
}
